import { languageHelper } from "../../../config/helperFunctions";
import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function Attendance() {
  const [columns] = useState([
    {
      header: languageHelper("SN"),
      accessorKey: "SN",
    
    },
    {
      header: languageHelper("Reference No"),
      accessorKey: "ReferenceNo"
    },
    {
      header: languageHelper("Date"),
      accessorKey: "Date",
    },
    {
      header: languageHelper("Employee"),
      accessorKey: "Employee",
    },
    {
      header: languageHelper("In Time"),
      accessorKey: "InTime",
    },
    {
      header: languageHelper("Out Time"),
      accessorKey: "OutTime",
    },
    {
      header: languageHelper("Update Time"),
      accessorKey: "UpdateTime",
    },
    {
      header: languageHelper("Time Count"),
      accessorKey: "TimeCount",
    },
    {
      header: languageHelper("Note"),
      accessorKey: "Note",
    },
   
    {
      header: languageHelper("Added By"),
      accessorKey: "AddedBy",
    },
    {
      header: languageHelper("Actions"),
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([

  
  ]);
  const [buttonData] = useState([   
    {
      buttonText: languageHelper("Add Attendance"),
      path: "addAttendanceForm"
    },
    
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper("Attendances")}
        buttonData={buttonData}
      

      />
    </main>
  );
}

export default Attendance;
